// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Notify,Toast,Slider } from 'vant'
//Vue.use(Notify);
//Vue.use(Toast);
Vue.prototype.$toast = Toast
Vue.prototype.$notify = Notify
Vue.config.productionTip = false

Vue.use(Slider);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js